import cohort from '@uswitch/koa-chansey/cohort'
import { useExperiences } from '@uswitch/ev-utils/context/selectors'

export const queryList = (url = '') => {
  const [, search = ''] = url.split('?')

  return search.split('&').reduce((acc, it) => {
    const [param, value = ''] = it.split('=')
    return acc.concat({ param, value })
  }, [])
}

export const appendQuery = (url = '', query = {}) => {
  if (!url.length) return ''

  const [domain, search = ''] = url.split('?')

  if (!search.length) return ''

  const paramsObj = search.split('&').reduce((acc, it) => {
    const [param, value = ''] = it.split('=')

    if (!param) return acc

    return { [param]: value, ...acc }
  }, query || {})

  const paramsString = Object.entries(paramsObj)
    .map(([param, value]) => `${param}=${value}`)
    .join('&')

  return paramsString.length ? `${domain}?${paramsString}` : domain
}

export const withTrailingSlash = s => s.replace(/\/?$/, '/')
export const withoutTrailingSlash = s => s.replace(/\/?$/, '')

export const pageForUrlEntity = (urlEntity, experiences) => {
  const { link, variants = [], variantFlag } = urlEntity.fields ? urlEntity.fields : urlEntity
  const index = cohort({ experiences }, variantFlag, null)
  const page = (index !== null && variants.length > index) || !link ? variants[index || 0] : link

  return page
}

export const usePageForUrlEntity = urlEntity => pageForUrlEntity(urlEntity, useExperiences())
